



































import {Component, Prop} from "vue-property-decorator"
import AbpBase from "../../../../../lib/abpbase"
import {DeleteStageSummary, GetStageSummaryStatistics} from "@/api/hd"
import AddOrEdit from './addOrEditDialysisSummary.vue'
import detail from './summaryDetail.vue'

@Component({
	components: {AddOrEdit, detail}
})
export default class DialysisSummary extends AbpBase {
	@Prop() patient: any
	patinentInfo:any = {}
	addShow = false
	spinShow = false
	detailShow = false
	addData: any = {}
	detailData: any = {}
	date:any = []
	private data : Array<any> = []
	options = {
		shortcuts: [
			{
				text: '一周',
				value() {
					const end = new Date();
					const start = new Date();
					start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
					return [start, end];
				}
			},
			{
				text: '一个月',
				value() {
					const end = new Date();
					const start = new Date(end.getFullYear(), end.getMonth() - 1, end.getDate() - 1)
					return [start, end];
				}
			},
			{
				text: '三个月',
				value() {
					const end = new Date();
					const start = new Date(end.getFullYear(), end.getMonth() - 3, end.getDate() - 1);
					return [start, end];
				}
			},
			{
				text: '一年',
				value() {
					const end = new Date();
					const start = new Date(end.getFullYear() - 1, end.getMonth(), end.getDate() - 1);
					return [start, end];
				}
			},
		]
	}
	add() {
		this.addData = {
			mode: 'add',
			patient: this.patient
		}
		this.addShow = true
	}
	edit(item: any) {
		this.addData = {
			mode: 'edit',
			patient: this.patient,
			data: item
		}
		this.addShow = true
	}
	detail(item: any) {
		this.detailData = {
			item: item,
			patient: this.patinentInfo
		}
		this.detailShow = true
	}
	deleteItem(item: any){
		this.$confirm('将删除该记录, 是否继续?', '提示', {
			confirmButtonText: '确定',
			cancelButtonText: '取消',
			type: 'warning'
		}).then(async () => {
			let res = await DeleteStageSummary({Id: item.id})
			this.getData()
		}).catch(() => {

		});
	}
	saveSuccess(){
		this.getData()
		this.addShow = false
	}
	created(){
		const end = new Date();
		const start = new Date(end.getFullYear(), end.getMonth() - 1, end.getDate() - 1)
		this.date = [start, end]
		this.getData()
	}
	private async getData() {
		this.spinShow = true
		let res = await GetStageSummaryStatistics({
			PatientId: this.patient.id,
			StartDate: this.date[0],
			EndDate: this.date[1]
		})
		this.patinentInfo = res.objects.pat
		this.data = res.objects.items
		this.spinShow = false
	}
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/electronicMedicalRecord/patient/parts/treatmentAnalysis/dialysisSummary.vue